var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var getIterator = require('get-iterator');

var defer = require('p-defer');

module.exports = function (writable) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source) {
      var errPromise, closePromise, endingPromise, finishPromise, drainPromise, errorHandler, closeHandler, finishHandler, drainHandler, _end, getNext, result;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              source = getIterator(source);
              errPromise = defer();
              closePromise = defer();
              endingPromise = defer();
              finishPromise = defer();

              errorHandler = function errorHandler(err) {
                return errPromise.reject(err);
              };

              closeHandler = function closeHandler() {
                return closePromise.resolve({
                  closed: true
                });
              };

              finishHandler = function finishHandler() {
                return finishPromise.resolve({
                  finished: true
                });
              };

              drainHandler = function drainHandler() {
                if (drainPromise) drainPromise.resolve({
                  drained: true
                });
              }; // There's no event to determine the start of a call to .end()


              _end = writable.end.bind(writable);

              writable.end = function () {
                endingPromise.resolve({
                  ending: true
                });
                return _end.apply(void 0, arguments);
              };

              writable.on('error', errorHandler).on('close', closeHandler).on('finish', finishHandler).on('drain', drainHandler);

              getNext = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          return _context.abrupt("return", source.next());

                        case 4:
                          _context.prev = 4;
                          _context.t0 = _context["catch"](0);
                          writable.destroy(_context.t0);
                          return _context.abrupt("return", errPromise.promise);

                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 4]]);
                }));

                return function getNext() {
                  return _ref2.apply(this, arguments);
                };
              }();

              _context2.prev = 13;

            case 14:
              if (!true) {
                _context2.next = 39;
                break;
              }

              _context2.next = 17;
              return Promise.race([errPromise.promise, closePromise.promise, endingPromise.promise, finishPromise.promise, getNext()]);

            case 17:
              result = _context2.sent;

              if (!(result.closed || result.finished)) {
                _context2.next = 20;
                break;
              }

              return _context2.abrupt("break", 39);

            case 20:
              if (!result.ending) {
                _context2.next = 24;
                break;
              }

              _context2.next = 23;
              return Promise.race([errPromise.promise, // TODO: do we need to wait on close? If slow end and destroy is
              // called then what is emitted? close or finish?
              closePromise.promise, finishPromise.promise]);

            case 23:
              return _context2.abrupt("break", 39);

            case 24:
              if (!writable.destroyed) {
                _context2.next = 28;
                break;
              }

              _context2.next = 27;
              return Promise.race([errPromise.promise, closePromise.promise]);

            case 27:
              return _context2.abrupt("break", 39);

            case 28:
              if (!result.done) {
                _context2.next = 33;
                break;
              }

              writable.end();
              _context2.next = 32;
              return Promise.race([errPromise.promise, // TODO: do we need to wait on close? If slow end and destroy is
              // called then what is emitted? close or finish?
              closePromise.promise, finishPromise.promise]);

            case 32:
              return _context2.abrupt("break", 39);

            case 33:
              if (writable.write(result.value)) {
                _context2.next = 37;
                break;
              }

              drainPromise = defer();
              _context2.next = 37;
              return Promise.race([errPromise.promise, closePromise.promise, finishPromise.promise, drainPromise.promise]);

            case 37:
              _context2.next = 14;
              break;

            case 39:
              _context2.prev = 39;
              writable.removeListener('error', errorHandler).removeListener('close', closeHandler).removeListener('finish', finishHandler).removeListener('drain', drainHandler); // End the iterator if it is a generator

              if (!(typeof source.return === 'function')) {
                _context2.next = 44;
                break;
              }

              _context2.next = 44;
              return source.return();

            case 44:
              return _context2.finish(39);

            case 45:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[13,, 39, 45]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};